/**
 * Created by akrio on 2018/3/23.
 */
import { DRAG_DROP_PUBLISHER_LIST } from "../mutation-types";

export default {
  state: {
    publishers: {},
  },
  mutations: {
    [DRAG_DROP_PUBLISHER_LIST](state, publishers) {
      state.publishers = publishers;
    },
  },
  getters: {
    [DRAG_DROP_PUBLISHER_LIST](state) {
      if (state.publishers === null) {
        return {};
      } else {
        return state.publishers;
      }
    },
  },
};
